import React from 'react';

const Card = ({
  children,
  className = '',
  padding = 'md',
  shadow = 'sm',
  rounded = 'lg',
  border = true,
  hover = false,
  onClick
}) => {
  const getPaddingClasses = (padding) => {
    switch (padding) {
      case 'none': return '';
      case 'sm': return 'p-4';
      case 'md': return 'p-6';
      case 'lg': return 'p-8';
      default: return 'p-6';
    }
  };

  const getShadowClasses = (shadow) => {
    switch (shadow) {
      case 'none': return '';
      case 'sm': return 'shadow-sm';
      case 'md': return 'shadow-md';
      case 'lg': return 'shadow-lg';
      default: return 'shadow-sm';
    }
  };

  const getRoundedClasses = (rounded) => {
    switch (rounded) {
      case 'none': return '';
      case 'md': return 'rounded-md';
      case 'lg': return 'rounded-lg';
      case 'xl': return 'rounded-xl';
      default: return 'rounded-lg';
    }
  };

  const paddingClasses = getPaddingClasses(padding);
  const shadowClasses = getShadowClasses(shadow);
  const roundedClasses = getRoundedClasses(rounded);
  const borderClasses = border ? 'border border-gray-200 dark:border-gray-700' : '';
  const hoverClasses = hover ? 'hover:shadow-md dark:hover:shadow-gray-900/50 transition-shadow cursor-pointer' : '';
  const interactiveClasses = onClick ? 'cursor-pointer' : '';

  return (
    <div
      className={`
        bg-white dark:bg-gray-800
        ${roundedClasses}
        ${shadowClasses}
        ${borderClasses}
        ${paddingClasses}
        ${hoverClasses}
        ${interactiveClasses}
        ${className}
      `}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default Card;
